import type { RecipeNames } from '@farmersdog/constants';

export const cvr_weight_override = 'cvr_weight_override';
export const cvr_global_discount_override = 'cvr_globaldiscount_override';
export const cvr_default_discount = 'cvr_default_discount';

export enum FeatureName {
  CVR_DEFAULT_DISCOUNT = 'cvr_default_discount',
  CVR_GLOBAL_DISCOUNT_OVERRIDE = 'cvr_globaldiscount_override',
  CVR_HEALTH_ISSUE_URINARY_STONES = 'cvr_health_issue_urinary_stones',
  CVR_SURPRISE_HIGHER_DISCOUNT = 'cvr_surprise_higher_discount',
  CVR_WEIGHT_OVERRIDE = 'cvr_weight_override',
  CVR_TREATS_IN_CHECKOUT_UI = 'cvr_treats_in_checkout_ui',
  CVR_SIGNUP_ICON_UPDATE = 'cvr_signup_icon_update',
  CVR_TOSA_DISCOUNT_BANNER_COPY = 'cvr_tosa_discount_banner_copy',
  CVR_CONSOLIDATE_ME_PAGES = 'cvr_consolidate_me_pages',
  AC_ME3_PAGE = 'ac_me3_page',
  AC_ALT_GET_STARTED_PAGE = 'ac_alt_get_started_page',
  VET_CREATE_PLAN_SIGNUP = 'VET_CREATE_PLAN_SIGNUP',
  CVR_ME_PAGE_TERMS_PRIVACY_CHECKBOX = 'cvr_me_page_terms_privacy_checkbox',
  CVR_PET_PICKY_COPY = 'cvr_pet_picky_copy',
}

export enum ToggleTreatments {
  off = 'off',
  on = 'on',
  control = 'control',
}

export enum RecipePagePackOrderEnum {
  off = 'off',
  chicken_first = 'chicken_first',
}

export enum SkipGetStartedTreatments {
  off = 'off',
  same_copy = 'same_copy',
  new_copy = 'new_copy',
  no_copy = 'no_copy',
}

export enum CvrSurpriseHigherDiscountTreatments {
  off = 'off',
  recipes = 'recipes',
  checkout = 'checkout',
}

export enum CvrTreatsInCheckoutUiTreatments {
  control = 'control',
  off = 'off',
  page = 'page',
}

export enum CvrPriorFoodTypeProgressionTreatments {
  off = 'off',
  on = 'on',
}
export enum CvrSignupCardSelectorsTreatments {
  off = 'off',
  with_continue_button = 'with_continue_button',
  without_continue_button = 'without_continue_button',
  control = 'control',
}

export enum AcMe3PageTreatments {
  off = 'off',
  me3_page_only_copy_change = 'me3_page_only_copy_change',
}

export enum AcAltGetStartedPageTreatments {
  off = 'off',
  portions_and_price = 'portions_and_price',
  personalized_nutrition = 'personalized_nutrition',
}

// Configs
export interface RecipePagePackOrderConfig {
  recipeOrder: RecipeNames[];
}
